/* unplugin-vue-components disabled */import { render } from "./Realtimedynamic.vue?vue&type=template&id=21dfa9de&scoped=true"
import script from "./Realtimedynamic.vue?vue&type=script&lang=js"
export * from "./Realtimedynamic.vue?vue&type=script&lang=js"

import "./Realtimedynamic.vue?vue&type=style&index=0&id=21dfa9de&lang=less&scoped=true"
import "./Realtimedynamic.vue?vue&type=style&index=1&id=21dfa9de&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dfa9de"]])

export default __exports__